<template>
  <b-form @submit.prevent="submitVehicle()">
    <b-form-row>
      <b-col cols="12">
        <b-form-group>
          <label for="reference" v-translate>Reference <small class="text-danger">(required)</small></label>
          <b-form-input id="reference" v-model="theVehicle.reference" required />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <label for="plate-number">
            <translate>Plate number</translate>
            <small class="text-danger" v-if="theVehicle.vehicle_type_id !== null && vehicleTypes.find(x => x.id === theVehicle.vehicle_type_id).is_registrable" v-translate>(required)</small></label>
          <b-form-input id="plate-number" v-model="theVehicle.plate_number" :required="theVehicle.vehicle_type_id !== null && theVehicle.vehicle_type_id !== vehicleTypesSelect.find(x => x.text === 'bicycle').value" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label for="vehicle-type" v-translate>Vehicle type <small class="text-danger">(required)</small></label>
          <b-form-select id="vehicle-type" v-model="theVehicle.vehicle_type_id" :options="vehicleTypesSelect" required>
            <template slot="first">
              <option :value="null" disabled v-translate>-- Select an option --</option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <label for="vehicle-insurance-expiration" v-translate>Vehicle Insurance Exp. Date</label>
          <b-input-group>
            <b-form-input id="vehicle-insurance-expiration" v-model="theVehicle.insurance_expiration_date" type="date" />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="6" class="mb-3 text-center">
        <h6 v-translate>Vehicle Card</h6>
        <div v-show="theVehicle.vehicle_card_picture">
          <b-img v-if="theVehicle.vehicle_card_picture" rounded="rounded" :src="theVehicle.vehicle_card_picture" style="width: auto; height: auto; max-width: 100px; max-height: 100px;" blank-color="#777" alt="img" class="m-1" /><br>
          <b-button pill size="sm" v-b-modal.modalUploadVehicleDocumentImage @click.prevent="uploadingField = 'vehicle_card_picture'">
            <translate>Change</translate>
          </b-button>
          <b-button pill size="sm" variant="danger" @click.stop="deleteDocumentImage('vehicle_card_picture')" style="padding: .5rem .65rem">
            <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
          </b-button>
        </div>
        <div v-show="!theVehicle.vehicle_card_picture">
          <b-button size="sm" v-b-modal.modalUploadVehicleDocumentImage @click.prevent="uploadingField = 'vehicle_card_picture'" v-translate>Vehicle Card Photo</b-button>
        </div>
      </b-col>
      <b-col cols="6" class="mb-3 text-center">
        <h6 v-translate>Insurance Card</h6>
        <div v-show="theVehicle.insurance_card_picture">
          <b-img v-if="theVehicle.insurance_card_picture" rounded="rounded" :src="theVehicle.insurance_card_picture" style="width: auto; height: auto; max-width: 100px; max-height: 100px;" blank-color="#777" alt="img" class="m-1" /><br>
          <b-button pill size="sm" v-b-modal.modalUploadVehicleDocumentImage @click.prevent="uploadingField = 'insurance_card_picture'">
            <translate>Change</translate>
          </b-button>
          <b-button pill size="sm" variant="danger" @click.stop="deleteDocumentImage('insurance_card_picture')" style="padding: .5rem .65rem">
            <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
          </b-button>
        </div>
        <div v-show="!theVehicle.insurance_card_picture">
          <b-button size="sm" v-b-modal.modalUploadVehicleDocumentImage @click.prevent="uploadingField = 'insurance_card_picture'" v-translate>Insurance Card Photo</b-button>
        </div>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col cols="12" class="text-center form-actions">
        <b-form-group>
          <b-button type="submit" variant="secondary" v-translate>Save</b-button>
          <b-button type="button" @click.prevent="emitCancel" variant="outline-secondary" v-translate>Cancel</b-button>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-modal id="modalUploadVehicleDocumentImage" ref="modalUploadVehicleDocumentImage" :hide-footer="true">
      <div slot="modal-title" v-translate>Add a new document image</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <profile-picture-uploader @updateProfileImage="updateDocumentImage" />
    </b-modal>
  </b-form>
</template>

<script>
import ProfilePictureUploader from '@/components/ProfilePictureUploader'

export default {
  name: 'VehicleForm',
  components: {
    ProfilePictureUploader
  },
  props: {
    vehicle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    user: {
      type: Object,
      default: () => {
        return {}
      }
    },
    company: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      theVehicle: {
        reference: null,
        plate_number: null,
        vehicle_type_id: null,
        vehicle_card_picture: null,
        insurance_card_picture: null,
        insurance_expiration_date: null
      },
      uploadingField: null
    }
  },
  created() {
    this.fetchVehicleTypes()
  },
  mounted() {
    if (this.vehicle.id) {
      this.theVehicle = {...this.vehicle}
    }
  },
  methods: {
    submitVehicle() {
      let endpoint
      if (this.user && this.user.id) {
        if (this.vehicle && this.vehicle.id) {
          endpoint = this.$appConfig.api.baseUrl + 'users/' + this.user.id + '/vehicles/' + this.vehicle.id
        } else {
          endpoint = this.$appConfig.api.baseUrl + 'users/' + this.user.id + '/vehicles'
        }
      } else {
        if (this.vehicle && this.vehicle.id) {
          endpoint = this.$appConfig.api.baseUrl + 'companies/' + this.company.id + '/vehicles/' + this.vehicle.id
        } else {
          endpoint = this.$appConfig.api.baseUrl + 'companies/' + this.company.id + '/vehicles'
        }
      }
      if (this.theVehicle.vehicle_type_id === this.vehicleTypesSelect.find(x => x.text === 'bicycle').value && this.theVehicle.plate_number === '') {
        this.theVehicle.plate_number = null
      }
      if (this.vehicle && this.vehicle.id) {
        this.$http.patch(endpoint, this.theVehicle)
          .then(response => {
            this.emitSuccess()
          })
      } else {
        this.$http.post(endpoint, this.theVehicle)
          .then(response => {
            this.emitSuccess()
          })
      }
    },
    updateDocumentImage(url) {
      this.theVehicle[this.uploadingField] = url
      this.$refs.modalUploadVehicleDocumentImage.hide()
    },
    deleteDocumentImage(documentField) {
      if (confirm(this.$gettext('Are you sure you want to DELETE this document picture?'))) {
        this.theVehicle[documentField] = null
      }
    },
    emitSuccess() {
      this.$emit('success', true)
    },
    emitCancel() {
      this.$emit('cancel', true)
    }
  }
}
</script>
